import SweetAlert from 'sweetalert2';

(function () {
    'use strict';

    /* --------------------------
       Helpers DOM & dates
    --------------------------- */
    const qs  = (s,c)=> (c||document).querySelector(s);
    const qsa = (s,c)=> Array.prototype.slice.call((c||document).querySelectorAll(s));
    const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
    function parseISO(d){ const m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(d||''); return m?new Date(+m[1],+m[2]-1,+m[3]):null; }
    function daysDiff(a,b){ const A=new Date(a.getFullYear(),a.getMonth(),a.getDate()); const B=new Date(b.getFullYear(),b.getMonth(),b.getDate()); return Math.round((B-A)/86400000)+1; }

    /* --------------------------
       Random days helpers (localStorage)
    --------------------------- */
    function shuffle(arr){
        const a = arr.slice();
        for (let i=a.length-1; i>0; i--){
            const j = Math.floor(Math.random()*(i+1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }
    function randomMapKey(calId){ return `wfaCal:${calId}:randomMap`; }
    function readRandomMap(calId){
        try{
            const raw = localStorage.getItem(randomMapKey(calId));
            const arr = JSON.parse(raw || '[]');
            return Array.isArray(arr) ? arr.map(Number).filter(Number.isFinite) : [];
        }catch{ return []; }
    }
    function writeRandomMap(calId, arr){
        try{ localStorage.setItem(randomMapKey(calId), JSON.stringify(arr)); }
        catch{}
        return arr;
    }

    /* --------------------------
       SweetAlert helpers (optionnel)
    --------------------------- */
    function swalLoading(title='Veuillez patienter...'){
        SweetAlert.fire({title,allowOutsideClick:false,allowEscapeKey:false,showConfirmButton:false,didOpen:()=>SweetAlert.showLoading()});
    }
    function swalClose(){ SweetAlert.close(); }
    function swalError(msg='Une erreur est survenue'){ SweetAlert.fire({icon:'error',title:'Oups…',html:String(msg)}); }

    /* --------------------------
       Inscription & email (localStorage)
    --------------------------- */
    function regKey(calId){ return `wfaCal:${calId}:registered`; }
    function isRegistered(calId){ try{ return localStorage.getItem(regKey(calId))==='1'; }catch{ return false; } }
    function setRegistered(calId){ try{ localStorage.setItem(regKey(calId),'1'); }catch{} }

    function emailKey(calId){ return `wfaCal:${calId}:email`; }
    function getEmail(calId){ try{ return localStorage.getItem(emailKey(calId)) || ''; }catch{ return ''; } }
    function setEmail(calId, email){ try{ if(email) localStorage.setItem(emailKey(calId), String(email)); }catch{} }

    /* --------------------------
       Jours ouverts (localStorage)
    --------------------------- */
    function openedKey(calId){ return `wfaCal:${calId}:openedDays`; }
    function readOpened(calId){
        try{ const raw=localStorage.getItem(openedKey(calId)); const arr=JSON.parse(raw||'[]'); return Array.isArray(arr)?arr.map(Number).filter(Number.isFinite):[]; }
        catch{ return []; }
    }
    function writeOpened(calId, arr){
        try{ const uniq=[...new Set(arr.map(Number).filter(Number.isFinite))].sort((a,b)=>a-b); localStorage.setItem(openedKey(calId), JSON.stringify(uniq)); return uniq; }
        catch{ return arr; }
    }
    function addOpened(calId, day){ const list=readOpened(calId); if(!list.includes(day)){ list.push(day); writeOpened(calId,list); } }

    /* --------------------------
       Reward rendering
    --------------------------- */
    function setCellReward(cell, payload){
        if (!cell || !payload) return;
        const rewardBox = cell.querySelector('.wfa-cal-reward');
        if (!rewardBox) return;

        const reward = payload.reward || null;
        rewardBox.innerHTML = '';
        rewardBox.classList.remove('is-discount','is-product','is-other','is-unknown','is-empty');

        const esc = s => String(s||'')
            .replace(/&/g,'&amp;').replace(/</g,'&lt;')
            .replace(/>/g,'&gt;').replace(/"/g,'&quot;')
            .replace(/'/g,'&#39;');

        const renderImageOrText = ({cover, url, name, text}) => {
            const safeUrl  = (url && url !== '#') ? url : '';
            const safeName = esc(name || text || '');

            if (cover) {
                if (safeUrl) {
                    return `
                <a class="wfa-reward-link" href="${safeUrl}" target="_blank" rel="noopener">
                  <img class="wfa-reward-cover" src="${cover}" alt="${safeName}">
                </a>
            `;
                }
                return `
            <img class="wfa-reward-cover" src="${cover}" alt="${safeName}">
        `;
            }

            if (safeUrl) {
                return `
            <a class="wfa-reward-link wfa-reward-name" href="${safeUrl}" target="_blank" rel="noopener">
              ${safeName}
            </a>
        `;
            }

            return `<div class="wfa-reward-name">${safeName}</div>`;
        };

        // empty cell (no reward)
        if (!reward) {
            rewardBox.classList.add('is-empty');

            const emptyCover =
                (typeof window.noRewardCover !== 'undefined' && window.noRewardCover) ||
                (typeof noRewardCover !== 'undefined' && noRewardCover) ||
                '';

            if (emptyCover) {
                rewardBox.innerHTML = `
          <div class="wfa-reward-empty">
            <img class="wfa-reward-cover" src="${emptyCover}" alt="${esc(window.trad_no_reward || 'Pas de lot')}">
          </div>
        `;
            } else {
                rewardBox.innerHTML = `
          <div class="wfa-reward-name">${esc(window.trad_no_reward || 'Pas de lot aujourd’hui')}</div>
        `;
            }

            try { cell.dataset.payload = JSON.stringify(payload); } catch(e){}
            return;
        }

        // DISCOUNT: show cover if provided, else show code
        if (reward.type === 'discount') {
            rewardBox.classList.add('is-discount');

            const cover = reward.cover || reward.image || '';
            const url   = reward.url || '#';
            const name  = reward.name || reward.code || '';

            rewardBox.innerHTML = cover
                ? renderImageOrText({ cover, url, name })
                : `<div class="wfa-reward-code">${esc(reward.code || '')}</div>`;
        }

        // PRODUCT: already supports cover override
        else if (reward.type === 'product') {
            rewardBox.classList.add('is-product');

            const cover = reward.cover || reward.image || '';
            const url   = reward.url || '#';
            const name  = reward.name || '';

            rewardBox.innerHTML = renderImageOrText({ cover, url, name });
        }

        // OTHER: supports cover too
        else if (reward.type === 'other') {
            rewardBox.classList.add('is-other');

            const cover = reward.cover || reward.image || '';
            const url   = reward.url || '#';
            const text  = reward.text || reward.name || '';

            rewardBox.innerHTML = cover
                ? renderImageOrText({ cover, url, text })
                : `<div class="wfa-reward-name">${esc(text)}</div>`;
        }

        // unknown types fallback
        else {
            rewardBox.classList.add('is-unknown');

            const cover = reward.cover || reward.image || '';
            const url   = reward.url || '#';
            const name  = reward.name || reward.text || reward.code || '';

            rewardBox.innerHTML = renderImageOrText({ cover, url, name });
        }

        try { cell.dataset.payload = JSON.stringify(payload); } catch(e){}
    }

    function rewardsKey(calId){ return `wfaCal:${calId}:rewardsMap`; }

    function readRewardsMap(calId){
        try { return JSON.parse(localStorage.getItem(rewardsKey(calId)) || '{}') || {}; }
        catch { return {}; }
    }

    function writeRewardsMap(calId, map){
        try { localStorage.setItem(rewardsKey(calId), JSON.stringify(map)); }
        catch(e){}
    }

    function saveRewardLocal(calId, day, payload){
        const map = readRewardsMap(calId);
        map[String(day)] = payload;
        writeRewardsMap(calId, map);
    }

    function ensureWowStyles(){
        if (document.getElementById('wfa-wow-style')) return;
        const css = `
  .wfa-wow{position:fixed;inset:0;z-index:9999;display:grid;place-items:center;background:rgba(0,0,0,.55);animation:wfaFadeIn .2s ease-out both}
  @keyframes wfaFadeIn{from{opacity:0}to{opacity:1}}
  .wfa-wow__card{position:relative;width:min(560px,92vw);padding:28px 24px;border-radius:18px;background:radial-gradient(120% 120% at 50% 0%,#1e1e1e 0%,#111 60%,#0b0b0b 100%);box-shadow:0 30px 100px rgba(0,0,0,.5),inset 0 0 0 1px rgba(255,255,255,.06);color:#fff;text-align:center;transform:translateY(12px) scale(.98);animation:wfaPop .25s cubic-bezier(.2,.9,.2,1.2) .05s both}
  @keyframes wfaPop{to{transform:translateY(0) scale(1)}}
  .wfa-wow__title{font-size:clamp(28px,4.2vw,40px);font-weight:800;letter-spacing:.3px;margin:6px 0 4px}
  .wfa-wow__subtitle{opacity:.85;margin:25px 0 16px}
  .wfa-wow__btn{display:inline-block;margin-top:14px;padding:10px 22px;border:0;border-radius:999px;background:#ffd76a;color:#222;font-weight:700;cursor:pointer;box-shadow:0 10px 24px rgba(255,215,106,.25)}
  .wfa-wow__btn:active{transform:translateY(1px)}
  .wfa-wow__reward{margin-top:8px;font-size:15px}
  .wfa-wow__reward a{color:#ffd76a;text-decoration:underline}
  #wfa-wow-canvas{position:fixed;inset:0;pointer-events:none}
  .wfa-no-scroll{overflow:hidden}
  .wfa-wow__reward img.wfa-reward-cover{max-width:220px;max-height:160px;object-fit:contain;display:block;margin:0 auto 8px}
  `;
        const style = document.createElement('style');
        style.id = 'wfa-wow-style';
        style.textContent = css;
        document.head.appendChild(style);
    }

    function showOverlay({ win, reward }) {
        ensureWowStyles();

        const hasConsolation = !win && !!reward;

        const title = win
            ? trad_win
            : (hasConsolation ? trad_win_gift : trad_tomorrow);

        const subtitle = win
            ? trad_unlock_reward
            : (hasConsolation
                ? trad_no_reward
                : trad_no_reward_tomorrow);

        const wrap = document.createElement('div');
        wrap.className = 'wfa-wow';
        wrap.innerHTML = `
  <canvas id="wfa-wow-canvas" aria-hidden="true"></canvas>
  <div class="wfa-wow__card" role="dialog" aria-modal="true">
    <div class="wfa-wow__title">${title}</div>
     <div class="wfa-wow__subtitle">
      ${subtitle || ''}
    </div>
    ${(!win && trad_no_reward_tomorrow && trad_no_reward_tomorrow !== subtitle)
            ? `<div class="wfa-wow__message">${trad_no_reward_tomorrow}</div>`
            : ''}

    <div class="wfa-wow__reward">
      ${(win || hasConsolation) ? renderReward(reward) : ''}
    </div>
    <button type="button" class="wfa-wow__btn">OK</button>
  </div>
`;
        document.body.appendChild(wrap);

        document.documentElement.classList.add('wfa-no-scroll');
        document.body.classList.add('wfa-no-scroll');

        const cvs = wrap.querySelector('#wfa-wow-canvas');
        const ctx = cvs.getContext('2d');
        let W, H, parts = [], raf;
        function resize(){ W=cvs.width=innerWidth; H=cvs.height=innerHeight; }
        resize(); addEventListener('resize', resize);

        if (win) {
            const N = 160;
            for (let i=0;i<N;i++) parts.push({
                x: Math.random()*W, y: -Math.random()*H*0.4,
                vy: 1 + Math.random()*2.2, vx: (Math.random()*0.6)-0.3,
                rot: Math.random()*Math.PI*2, spin: (Math.random()*0.08)-0.04,
                w: 6+Math.random()*7, h: 2+Math.random()*3, a:.9,
                hue: 40+Math.random()*60
            });
            (function tick(){
                ctx.clearRect(0,0,W,H);
                for (const p of parts){
                    p.x += p.vx + Math.sin((p.y+p.w)*0.02)*0.6;
                    p.y += p.vy; p.rot += p.spin;
                    ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.rot);
                    ctx.fillStyle = `hsl(${p.hue} 95% 60% / ${p.a})`;
                    ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h);
                    ctx.restore();
                    if (p.y>H+30) { p.y=-20; p.x=Math.random()*W; }
                }
                raf = requestAnimationFrame(tick);
            })();
        } else {
            const N=70;
            for (let i=0;i<N;i++) parts.push({
                x: W/2, y:H/2, vx:(Math.random()*2-1)*4.5, vy:(Math.random()*2-1)*4.5,
                r:2+Math.random()*2.5, a:1
            });
            (function tick(){
                ctx.clearRect(0,0,W,H);
                parts = parts.filter(p => (p.a-=.015)>0).map(p=>{
                    p.x+=p.vx; p.y+=p.vy; p.vy+=.08;
                    ctx.beginPath(); ctx.fillStyle=`rgba(255,255,255,${p.a})`;
                    ctx.arc(p.x,p.y,p.r,0,Math.PI*2); ctx.fill();
                    return p;
                });
                if (parts.length) raf = requestAnimationFrame(tick);
            })();
        }

        function close(){
            cancelAnimationFrame(raf);
            removeEventListener('resize', resize);
            wrap.remove();
            document.documentElement.classList.remove('wfa-no-scroll');
            document.body.classList.remove('wfa-no-scroll');
        }
        wrap.querySelector('.wfa-wow__btn').addEventListener('click', close);
        wrap.addEventListener('click', e => { if (e.target === wrap) close(); });
        addEventListener('keydown', e=>{ if(e.key==='Escape') close(); }, { once:true });
    }

    // overlay reward renderer with cover support
    function renderReward(reward){
        if (!reward) return '';
        const esc = s => String(s||'')
            .replace(/&/g,'&amp;').replace(/</g,'&lt;')
            .replace(/>/g,'&gt;')
            .replace(/"/g,'&quot;').replace(/'/g,'&#39;');

        const cover = reward.cover || reward.image || '';
        const url   = reward.url ? String(reward.url) : '#';
        const name  = esc(reward.name || reward.text || reward.code || '');

        if (cover) {
            return `
        <a href="${url}" target="_blank" rel="noopener">
          <img class="wfa-reward-cover" src="${cover}" alt="${name}">
        </a>
        ${name ? `<div class="wfa-reward-name">${name}</div>` : ''}
      `;
        }

        if (reward.type === 'product') {
            return `🛍️ <a href="${url}" target="_blank" rel="noopener">${name}</a>`;
        }
        if (reward.type === 'discount') {
            const code = reward.code
                ? `<span class="wfa-reward-code font-weight-bold">${window.trad_with_code} ${esc(reward.code)}</span>`
                : '';
            return `🎟️ ${name} ${code}`;
        }
        if (reward.text) return `🎁 ${esc(reward.text)}`;
        return '';
    }

    /* --------------------------
       Modal fallback (si BS absent)
    --------------------------- */
    function showModalById(id){
        const el = document.querySelector(id);
        if (!el) return;
        document.body.classList.add('modal-open');
        el.style.display = 'block';
        el.style.zIndex = '1050';
        el.removeAttribute('aria-hidden');
        el.setAttribute('aria-modal','true');
        el.setAttribute('role','dialog');
        el.classList.add('show');
        let bd = document.getElementById('wfa-fallback-backdrop');
        if (!bd) {
            bd = document.createElement('div');
            bd.id = 'wfa-fallback-backdrop';
            bd.className = 'modal-backdrop fade show';
            bd.style.zIndex = '1040';
            document.body.appendChild(bd);
            bd.addEventListener('click', ()=> hideModalById(id));
        }
    }

    function hideModalById(id){
        const el = document.querySelector(id);
        if (!el) return;
        el.classList.remove('show');
        el.style.display = 'none';
        el.setAttribute('aria-hidden','true');
        document.body.classList.remove('modal-open');
        const bd = document.getElementById('wfa-fallback-backdrop');
        if (bd) bd.remove();
    }

    /* --------------------------
       URL AJAX
    --------------------------- */
    function buildAjaxUrl(extra) {
        const url = new URL(window.location.href);
        url.searchParams.set('ajax', '1');
        Object.keys(extra || {}).forEach(k => url.searchParams.set(k, extra[k]));
        return url.toString();
    }

    function ensurePreview(){
        let el = document.getElementById('wfa-reward-preview');
        if (el) return el;

        el = document.createElement('div');
        el.id = 'wfa-reward-preview';
        el.className = 'wfa-reward-preview';
        document.body.appendChild(el);
        return el;
    }

    function buildBigPreview(reward){
        if (!reward) return '';

        const esc = s => String(s||'')
            .replace(/&/g,'&amp;').replace(/</g,'&lt;')
            .replace(/>/g,'&gt;').replace(/"/g,'&quot;')
            .replace(/'/g,'&#39;');

        if (reward.type === 'discount') {
            const cover = reward.cover || reward.image || '';
            const name  = esc(reward.name || '');
            const code  = esc(reward.code || '');
            return `
      <div class="wfa-preview-card is-discount">
        ${cover ? `<img style="max-width: 100%;" class="wfa-preview-cover" src="${cover}" alt="${name}">` : ''}
        <div class="wfa-preview-name">${name}</div>
        ${code ? `<div class="wfa-preview-code">${code}</div>` : ''}
      </div>
    `;
        }

        if (reward.type === 'product') {
            const cover = reward.cover || reward.image || '';
            const name  = esc(reward.name || '');

            return `
    <div class="wfa-preview-card is-product">
      ${cover ? `<img class="wfa-preview-cover" src="${cover}" alt="${name}">` : ''}
      <div class="wfa-preview-name">${name}</div>
    </div>
  `;
        }

        if (reward.type === 'other') {
            const cover = reward.cover || reward.image || '';
            const text  = esc(reward.text || reward.name || '');
            return `
    <div class="wfa-preview-card is-other">
      ${cover ? `<img style="max-width: 100%;" class="wfa-preview-cover" src="${cover}" alt="${text}">` : ''}
      <div class="wfa-preview-name">${text}</div>
    </div>
  `;
        }

        const cover = reward.cover || reward.image || '';
        const name  = esc(reward.name || reward.text || '');
        return `
    <div class="wfa-preview-card is-other">
      ${cover ? `<img style="max-width: 100%;" class="wfa-preview-cover" src="${cover}" alt="${name}">` : ''}
      <div class="wfa-preview-name">${name}</div>
    </div>
  `;
    }

    /* --------------------------
       Init
    --------------------------- */
    function init() {
        const root = qs('#wfa-calendar-front');
        if (!root) return;

        const calId   = root.getAttribute('data-cal-id') || '0';
        const dStart  = parseISO(root.getAttribute('data-start'));
        const dEnd    = parseISO(root.getAttribute('data-end'));
        const dToday  = parseISO(root.getAttribute('data-today'));
        if (!dStart || !dEnd || !dToday) return;

        const totalDays  = clamp(daysDiff(dStart, dEnd), 1, 31);
        const todayIndex = clamp(daysDiff(dStart, dToday), 1, totalDays);

        // flags : on lit d'abord le data-attr (tpl), sinon variable globale si elle existe
        const randomFlag =
            Number(root.getAttribute('data-random') || 0) ||
            (typeof random !== 'undefined' ? Number(random) : 0) ||
            (typeof window.random !== 'undefined' ? Number(window.random) : 0);

        const openBeforeFlag =
            Number(root.getAttribute('data-open-before') || 0) ||
            (typeof open_before !== 'undefined' ? Number(open_before) : 0) ||
            (typeof window.open_before !== 'undefined' ? Number(window.open_before) : 0);

        // applique random si demandé
        if (randomFlag === 1) {
            let randomMap = readRandomMap(calId);

            if (randomMap.length !== totalDays) {
                randomMap = shuffle(Array.from({ length: totalDays }, (_, i) => i + 1));
                writeRandomMap(calId, randomMap);
            }

            const cells = qsa('.wfa-cal-cell', root);
            cells.forEach((cell, i) => {
                const realDay = randomMap[i] ?? (i + 1);

                // valeur logique envoyée au serveur
                cell.dataset.day = String(realDay);

                // valeur visible dans ton tpl => <span>XX</span>
                const span = cell.querySelector('span');
                if (span) span.textContent = String(realDay);
            });
        }

        const dbHistory = (window.openedHistory && typeof window.openedHistory === 'object')
            ? window.openedHistory
            : {};

        const dbOpenedDays = Object.keys(dbHistory)
            .map(n => parseInt(n,10))
            .filter(Number.isFinite);

        const localRewards = readRewardsMap(calId);

        const opened = writeOpened(calId, [
            ...readOpened(calId),
            ...dbOpenedDays
        ]);

        qsa('.wfa-cal-cell', root).forEach(cell=>{
            const day = +cell.dataset.day;

            if (dbHistory[day]) {
                cell.classList.add('opened');
                setCellReward(cell, dbHistory[day]);
                return;
            }

            if (localRewards[String(day)]) {
                cell.classList.add('opened');
                setCellReward(cell, localRewards[String(day)]);
                return;
            }

            if (opened.includes(day)) {
                cell.classList.add('opened');
                return;
            }

            const isPast   = day < todayIndex;
            const isToday  = day === todayIndex;
            const canOpenPast = (openBeforeFlag === 1 && isPast);

            if (!isToday && !canOpenPast) {
                cell.classList.add('locked');
            }
        });

        const MODAL_ID = '#calendarModal';
        const form     = qs('#form-calendar') || qs('#form-participation');
        const closeBtn = qs('#calendarModalClose');

        let pendingDay  = null;
        let pendingCell = null;

        if (closeBtn) closeBtn.addEventListener('click', ()=> hideModalById(MODAL_ID));

        /* ---------- Soumission formulaire (REGISTER) ---------- */
        if (form) {
            form.addEventListener('submit', async function(e){
                e.preventDefault();

                const fd = new FormData(form);
                const emailFromForm = (fd.get('email') || '').toString().trim();
                setEmail(calId, emailFromForm);

                try {
                    swalLoading();
                    const res  = await fetch(buildAjaxUrl({ action:'register', id: calId }), {
                        method:'POST',
                        body: fd,
                        credentials:'same-origin',
                        headers: { 'X-Requested-With':'XMLHttpRequest' }
                    });
                    const json = await res.json().catch(()=>({ ok:false, error:'Erreur JSON' }));
                    swalClose();

                    if (!json.ok) { swalError(json.error || 'Enregistrement impossible'); return; }

                    setRegistered(calId);

                    const cellToOpen = pendingCell;
                    const dayToOpen  = pendingDay;

                    pendingCell = null;
                    pendingDay  = null;

                    hideModalById(MODAL_ID);

                    if (cellToOpen && dayToOpen !== null &&
                        !cellToOpen.classList.contains('locked') &&
                        !cellToOpen.classList.contains('opened')) {

                        swalLoading('Ouverture de la case…');
                        const r = await fetch(buildAjaxUrl({
                            action:'openDay',
                            id: calId,
                            day: dayToOpen,
                            email: emailFromForm
                        }), {
                            credentials:'same-origin',
                            headers: { 'X-Requested-With':'XMLHttpRequest' }
                        });
                        const data = await r.json().catch(()=>({ ok:false }));
                        swalClose();

                        if (data && data.ok) {
                            cellToOpen.classList.add('opened');
                            addOpened(calId, dayToOpen);
                            setCellReward(cellToOpen, data);
                            saveRewardLocal(calId, dayToOpen, data);
                            showOverlay({ win: !!data.win, reward: data.reward || null });
                        } else {
                            swalError((data && data.error) || 'Erreur à l’ouverture');
                        }
                    }
                } catch (err) {
                    swalClose();
                    swalError('Erreur réseau');
                } finally {
                    pendingCell = null; pendingDay = null;
                }
            });
        }

        root.addEventListener('click', async function(e){
            const cell = e.target.closest('.wfa-cal-cell');
            if (!cell) return;

            const day = +cell.dataset.day;

            if (!isRegistered(calId)) {
                pendingDay  = day;
                pendingCell = cell;
                showModalById(MODAL_ID);
                return;
            }

            if (cell.classList.contains('opened')) return;

            const isPast   = day < todayIndex;
            const isToday  = day === todayIndex;
            const isFuture = day > todayIndex;
            const canOpenPast = (openBeforeFlag === 1 && isPast);

            if (isFuture) {
                SweetAlert.fire({
                    icon: 'info',
                    title: trad_patience_title,
                    html: '',
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }

            if (!isToday && !canOpenPast) {
                return;
            }

            cell.classList.remove('locked');

            try {
                swalLoading(trad_open_box);
                const r = await fetch(buildAjaxUrl({
                    action:'openDay',
                    id: calId,
                    day,
                    email: getEmail(calId)
                }), {
                    credentials:'same-origin',
                    headers: { 'X-Requested-With':'XMLHttpRequest' }
                });
                const data = await r.json().catch(()=>({ ok:false }));
                swalClose();

                if (data && data.ok) {
                    cell.classList.add('opened');
                    addOpened(calId, day);
                    setCellReward(cell, data);
                    saveRewardLocal(calId, day, data);
                    showOverlay({ win: !!data.win, reward: data.reward || null });
                } else {
                    swalError((data && data.error) || 'Erreur à l’ouverture');
                }
            } catch {
                swalClose();
                swalError('Erreur réseau');
            }
        });

        const previewEl = ensurePreview();

        root.addEventListener('mousemove', (e) => {
            if (previewEl.classList.contains('show')) {
                previewEl.style.left = (e.pageX + 14) + 'px';
                previewEl.style.top  = (e.pageY + 14) + 'px';
            }
        });

        root.addEventListener('mouseenter', (e) => {
            const cell = e.target.closest('.wfa-cal-cell.opened');
            if (!cell) return;

            if (!cell.dataset.payload) return;

            try {
                const payload = JSON.parse(cell.dataset.payload);
                const reward = payload.reward || null;
                if (!reward) return;

                previewEl.innerHTML = buildBigPreview(reward);
                previewEl.classList.add('show');
            } catch(err){}
        }, true);

        root.addEventListener('mouseleave', (e) => {
            const cell = e.target.closest('.wfa-cal-cell.opened');
            if (!cell) return;

            previewEl.classList.remove('show');
            previewEl.innerHTML = '';
        }, true);

        if (window.jQuery) {
            jQuery(MODAL_ID).on('hidden.bs.modal', function(){ pendingCell=null; pendingDay=null; });
        } else if (window.bootstrap && bootstrap.Modal) {
            const el = qs(MODAL_ID);
            el && el.addEventListener('hidden.bs.modal', function(){ pendingCell=null; pendingDay=null; });
        }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();